// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d3e26a1","239":"0c1684f7","455":"af9a0495"}[chunkId] + ".chunk.js";
};